import './scananother.scss';
